/**
 * Editor metadata: labels + icons for each block type, and the field SCHEMAS
 * that drive the generic per-block property editor in CrmLandingDesigns.
 */
export const BLOCK_META = {
  hero: { label: 'Hero', icon: 'Sparkles' },
  marquee: { label: 'Scrolling Marquee', icon: 'ArrowRight' },
  stats: { label: 'Stats Row', icon: 'BarChart3' },
  features: { label: 'Feature Grid', icon: 'LayoutGrid' },
  steps: { label: 'How It Works', icon: 'ListChecks' },
  gallery: { label: 'Photo Gallery', icon: 'Images' },
  packages: { label: 'Packages (live)', icon: 'Package' },
  testimonials: { label: 'Testimonials', icon: 'Quote' },
  cta_banner: { label: 'CTA Banner', icon: 'Megaphone' },
  faq: { label: 'FAQ', icon: 'HelpCircle' },
  about: { label: 'About / Story', icon: 'BookOpen' },
  logo_strip: { label: 'Trust Badges', icon: 'ShieldCheck' },
  contact: { label: 'Contact', icon: 'Phone' },
  richtext: { label: 'Text Block', icon: 'Type' },
};

const F = (key, label, type, extra = {}) => ({ key, label, type, ...extra });

export const BLOCK_SCHEMAS = {
  hero: [
    F('eyebrow', 'Eyebrow', 'text'),
    F('title', 'Headline', 'text'),
    F('subtitle', 'Subheadline', 'textarea'),
    F('primary_label', 'Primary button label', 'text'),
    F('primary_href', 'Primary button link', 'text'),
    F('secondary_label', 'Secondary button label', 'text'),
    F('secondary_href', 'Secondary button link', 'text'),
    F('image', 'Image', 'image'),
    F('bg_style', 'Background style', 'select', { options: ['gradient', 'image', 'solid', 'split'] }),
    F('align', 'Alignment', 'select', { options: ['left', 'center'] }),
  ],
  marquee: [
    F('items', 'Marquee items', 'list', { itemFields: [F('label', 'Text', 'text')] }),
  ],
  stats: [
    F('title', 'Title (optional)', 'text'),
    F('items', 'Stats', 'list', { itemFields: [F('value', 'Value', 'text'), F('label', 'Label', 'text')] }),
  ],
  features: [
    F('title', 'Title', 'text'),
    F('subtitle', 'Subtitle', 'textarea'),
    F('columns', 'Columns', 'select', { options: [2, 3, 4] }),
    F('items', 'Features', 'list', { itemFields: [F('icon', 'Icon (name or emoji)', 'text'), F('title', 'Title', 'text'), F('text', 'Text', 'textarea'), F('link', 'Link (optional)', 'link')] }),
  ],
  steps: [
    F('title', 'Title', 'text'),
    F('subtitle', 'Subtitle', 'textarea'),
    F('items', 'Steps', 'list', { itemFields: [F('title', 'Title', 'text'), F('text', 'Text', 'textarea')] }),
  ],
  gallery: [
    F('title', 'Title', 'text'),
    F('subtitle', 'Subtitle', 'textarea'),
    F('layout', 'Layout', 'select', { options: ['grid', 'masonry', 'carousel'] }),
    F('images', 'Images', 'list', { itemFields: [F('url', 'Image', 'image'), F('caption', 'Caption', 'text')] }),
  ],
  packages: [
    F('title', 'Title', 'text'),
    F('subtitle', 'Subtitle', 'textarea'),
    F('note', 'Footnote', 'text'),
  ],
  testimonials: [
    F('title', 'Title', 'text'),
    F('items', 'Quotes', 'list', { itemFields: [F('quote', 'Quote', 'textarea'), F('name', 'Name', 'text'), F('detail', 'Detail', 'text'), F('rating', 'Rating (1-5)', 'number'), F('link', 'Link (optional)', 'link')] }),
  ],
  cta_banner: [
    F('title', 'Title', 'text'),
    F('subtitle', 'Subtitle', 'textarea'),
    F('cta_label', 'Button label', 'text'),
    F('cta_href', 'Button link', 'text'),
  ],
  faq: [
    F('title', 'Title', 'text'),
    F('items', 'Questions', 'list', { itemFields: [F('q', 'Question', 'text'), F('a', 'Answer', 'textarea')] }),
  ],
  about: [
    F('title', 'Title', 'text'),
    F('body', 'Body', 'textarea'),
    F('image', 'Image', 'image'),
    F('image_side', 'Image side', 'select', { options: ['left', 'right'] }),
  ],
  logo_strip: [
    F('title', 'Title', 'text'),
    F('items', 'Badges', 'list', { itemFields: [F('label', 'Label', 'text')] }),
  ],
  contact: [
    F('title', 'Title', 'text'),
    F('phone', 'Phone', 'text'),
    F('email', 'Email', 'text'),
    F('address', 'Address', 'text'),
    F('hours', 'Hours', 'text'),
  ],
  richtext: [
    F('title', 'Title', 'text'),
    F('body', 'Body', 'textarea'),
    F('align', 'Alignment', 'select', { options: ['left', 'center', 'right'] }),
  ],
};

export const THEME_FIELDS = [
  F('primary', 'Primary', 'color'),
  F('secondary', 'Secondary', 'color'),
  F('accent', 'Accent', 'color'),
  F('bg', 'Background', 'color'),
  F('surface', 'Surface', 'color'),
  F('text', 'Text', 'color'),
  F('muted', 'Muted text', 'color'),
  F('heading_font', 'Heading font', 'font'),
  F('body_font', 'Body font', 'font'),
  F('radius', 'Corner radius', 'select', { options: ['4px', '8px', '14px', '18px', '22px', '24px', '28px', '32px'] }),
];
